import { useEffect } from 'react'

/**
 * useMapPanelResize - Invalidates Leaflet's cached map size after the immersive
 * side panel's width transition finishes, so the map fills its new container correctly.
 * @atomic
 */
export function useMapPanelResize({ isImmersiveMode, panelState, mapRef }) {
  useEffect(() => {
    if (!isImmersiveMode) return
    const timer = setTimeout(() => {
      mapRef.current?.invalidateSize({ animate: false })
    }, 310)
    return () => clearTimeout(timer)
  }, [panelState, isImmersiveMode, mapRef])
}
